import React from 'react';
import { Form, Field } from 'react-final-form';
import { useCreateNode } from "services/Nodes";
import { Card, CardBody, CardHeader, CardText, Button } from "reactstrap";
import TextField from 'components/form/TextField';
import validator from 'validator';
import CheckboxField from "../../components/form/CheckboxField";

const validate = (values: any) => {
  const errors:any = {};

  if (!values.coordString || !validator.isLatLong(values.coordString)) {
    errors.coordString = 'Please enter a valid Lat Long'
  }

  return errors;
};

function CreateNodeForm() {
  const createNode = useCreateNode();

  const onSubmit = async (values:any) => {
    try {
      await createNode(values.coordString, values.withEdge);
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } catch (e) {
      window.alert(e.message);
    }
  };

  return (
    <Form
      // @ts-ignore
      validate={validate}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Card>
            <CardHeader>Create Node</CardHeader>
            <CardBody>
              <CardText>Enter a latitude and longitude value separated by a comma. (ie. 38.212114, -92.763505)</CardText>
              <TextField name='coordString' placeholder='yy.yyyyyy, xx.xxxxx' />
              <CheckboxField name='withEdge' label='Attach to nearest node on creation'/>
              <Button type='submit'>Submit</Button>
            </CardBody>
          </Card>
        </form>
      )}
    />
  );
}

export default CreateNodeForm;
